import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldSchemesEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-schemes-edit',
	path: '/secure/admin/EditFieldScreenScheme([!%]?[\\w]*).jspa',
};
